import Vue from "vue";
import Vuex from "vuex";
import isLoadedStatus from "./modules/isLoadedStatus";
import selectedSku from "./modules/selectedSku";
import lastUser from "./modules/lastUser";
import chat from "./modules/chat";
import createPersistedState from "vuex-persistedstate";
import surf from "./modules/surf";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    isLoadedStatus,
    selectedSku,
    lastUser,
    chat,
    surf,
  },
  plugins: [createPersistedState()],
});
